
// Funktionaler Import für EtSwiper wird nur bei Bedarf verwendet
let EtSwiper: any;

// Funktion zur Initialisierung eines Swipers
async function initSwiper(element: HTMLElement | Element) {
    // Dynamischer Import von EtSwiper, falls noch nicht geladen
    if (!EtSwiper) {
        const module = await import('../components/EtSwiper');
        EtSwiper = module.default;
    }

    if (EtSwiper) {
        let etSwiper: any;
        if ('etSwiper' in window) {
            // @ts-ignore
            etSwiper = window.etSwiper;
        } else {
            etSwiper = new EtSwiper();
            // @ts-ignore
            window.etSwiper = etSwiper;
        }

        // Instanz von Swiper erstellen
        etSwiper.initSwiper(element);
    }
}

// Watch for new swipers
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) {
                if (node.classList.contains('js_swiper')) {
                    initSwiper(node);
                }
                node.querySelectorAll('.js_swiper').forEach((element) => {
                    initSwiper(element);
                });
            }
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});

// Vorhandene Swiper auf der Seite initialisieren
document.querySelectorAll('.js_swiper').forEach((element) => {
    initSwiper(element);
});

